import { apiFetch, getApiHost } from '../utils/api';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const API_BASE_URL = getApiHost();

const Footer: React.FC = () => {
  const [burned, setBurned] = useState<number | null>(null);

  useEffect(() => {
    apiFetch(`${API_BASE_URL}/api/burn/stats`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.burned) setBurned(data.burned); })
      .catch(() => {});
  }, []);

  const formatBurned = (n: number): string => {
    if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (n >= 1_000) return (n / 1_000).toFixed(0) + 'K';
    return n.toLocaleString();
  };

  return (
    <footer className="border-t border-gray-800 bg-crypto-gray/30 mt-16">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* 3-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand Column */}
          <div>
            <div className="font-semibold text-white mb-2">Deepnets.ai</div>
            <p className="text-gray-500 text-sm mb-4">
              Scam detection for safer trading.
            </p>
            <div className="flex flex-col gap-1.5 text-sm">
              <a
                href="https://solscan.io/token/93VXFhKsGXsraivwdwAwoVXHKd4U1TFL64oQYpVjpump"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors font-mono text-xs"
                title="$DNET token on Solscan"
              >
                $DNET: 93VXFh...pVjpump
              </a>
              {burned !== null && (
                <a
                  href="https://solscan.io/token/93VXFhKsGXsraivwdwAwoVXHKd4U1TFL64oQYpVjpump"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-orange-400 transition-colors text-xs"
                  title={`${burned.toLocaleString()} DNET burned (${(burned / 10_000_000).toFixed(1)}% of supply)`}
                >
                  {formatBurned(burned)} burned
                </a>
              )}
            </div>
          </div>

          {/* Links Column */}
          <div>
            <div className="font-medium text-gray-400 text-sm uppercase tracking-wider mb-3">Resources</div>
            <div className="flex flex-col gap-2">
              <Link to="/tiers" className="text-gray-500 hover:text-white transition-colors text-sm">
                Tiers
              </Link>
              <Link to="/whitepaper" className="text-gray-500 hover:text-white transition-colors text-sm">
                Whitepaper
              </Link>
              <Link to="/api-docs" className="text-gray-500 hover:text-white transition-colors text-sm">
                API Docs
              </Link>
              <a
                href="https://www.tibane.net/staking/93VXFhKsGXsraivwdwAwoVXHKd4U1TFL64oQYpVjpump"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-green-400 transition-colors text-sm"
              >
                Stake $DNET
              </a>
            </div>
            <div className="font-medium text-gray-400 text-sm uppercase tracking-wider mb-3 mt-6">Legal</div>
            <div className="flex flex-col gap-2">
              <Link to="/terms" className="text-gray-500 hover:text-white transition-colors text-sm">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-gray-500 hover:text-white transition-colors text-sm">
                Privacy Policy
              </Link>
            </div>
          </div>

          {/* Social Column */}
          <div>
            <div className="font-medium text-gray-400 text-sm uppercase tracking-wider mb-3">Connect</div>
            <div className="flex flex-col gap-2">
              <a
                href="https://x.com/deepnets_ai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors text-sm flex items-center gap-2"
              >
                <i className="fab fa-x-twitter w-4"></i>
                @deepnets_ai
              </a>
              <a
                href="https://x.com/deepnets_agent"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors text-sm flex items-center gap-2"
              >
                <i className="fab fa-x-twitter w-4"></i>
                @deepnets_agent
              </a>
              <a
                href="https://x.com/i/chat/group_join/g2050256478343213064/QYTP6iN6Q6"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors text-sm flex items-center gap-2"
              >
                <i className="fas fa-comments w-4"></i>
                XChat group
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-600">
            <span>Percipio LLC</span>
            <span>Created by SciFantastic with curiosity</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
